module.exports = __webpack_public_path__ + "img/table-tree.113dc910.svg";